"use strict";
/**
 * Cross-platform navigation service
 * This abstraction works for both web (React Router) and mobile (React Navigation)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationHelpers = exports.ROUTES = exports.WebNavigationService = void 0;
// Web implementation using React Router
class WebNavigationService {
    constructor(navigate, goBack) {
        this.navigateFn = navigate;
        this.goBackFn = goBack;
    }
    navigate(route, params) {
        const path = this.buildPath(route, params);
        this.navigateFn(path);
    }
    goBack() {
        this.goBackFn();
    }
    replace(route, params) {
        const path = this.buildPath(route, params);
        this.navigateFn(path);
    }
    canGoBack() {
        // Check if we're in a browser environment
        if (typeof window !== 'undefined' && window.history) {
            return window.history.length > 1;
        }
        // Fallback for non-browser environments (React Native/server)
        return true;
    }
    buildPath(route, params) {
        if (!params)
            return route;
        const queryParams = new URLSearchParams();
        // Handle specific route parameters
        let path = route;
        if (params.watchlistId && route.includes(':watchlistId')) {
            path = path.replace(':watchlistId', params.watchlistId);
        }
        if (params.movieId && route.includes(':movieId')) {
            path = path.replace(':movieId', params.movieId);
        }
        if (params.userId && route.includes(':userId')) {
            path = path.replace(':userId', params.userId);
        }
        if (params.personId && route.includes(':personId')) {
            path = path.replace(':personId', params.personId);
        }
        // Handle query parameters
        if (params.tab !== undefined) {
            queryParams.set('tab', params.tab.toString());
        }
        if (params.targetUserId) {
            queryParams.set('userId', params.targetUserId);
        }
        if (params.shared) {
            queryParams.set('shared', 'true');
        }
        // Add any additional parameters
        Object.entries(params).forEach(([key, value]) => {
            if (!['watchlistId', 'movieId', 'userId', 'personId', 'tab', 'targetUserId', 'shared'].includes(key)) {
                if (value !== undefined && value !== null) {
                    queryParams.set(key, value.toString());
                }
            }
        });
        const queryString = queryParams.toString();
        return queryString ? `${path}?${queryString}` : path;
    }
}
exports.WebNavigationService = WebNavigationService;
// Routes constants for cross-platform use
exports.ROUTES = {
    HOME: '/',
    WATCHLIST_DETAIL: '/watchlist/:watchlistId',
    MOVIE_DETAIL: '/movie/:movieId',
    PROFILE: '/profile',
    OTHER_PROFILE: '/profile/:userId',
    SEARCH: '/search',
    RECOMMENDATIONS: '/recommendations',
    SETTINGS: '/settings',
    NOTIFICATIONS: '/notifications',
    PERSON_DETAIL: '/person/:personId',
    USERS_LIST: '/users',
};
// Navigation helper functions
exports.NavigationHelpers = {
    navigateToWatchlist: (nav, watchlistId, tabIndex, targetUserId) => {
        nav.navigate(exports.ROUTES.WATCHLIST_DETAIL, {
            watchlistId,
            tab: tabIndex,
            targetUserId,
        });
    },
    navigateToMovie: (nav, movieId, tabIndex) => {
        nav.navigate(exports.ROUTES.MOVIE_DETAIL, {
            movieId,
            tab: tabIndex,
        });
    },
    navigateToUserProfile: (nav, userId) => {
        nav.navigate(exports.ROUTES.OTHER_PROFILE, { userId });
    },
    navigateToPersonDetail: (nav, personId) => {
        nav.navigate(exports.ROUTES.PERSON_DETAIL, { personId });
    },
    navigateToSearch: (nav) => {
        nav.navigate(exports.ROUTES.SEARCH);
    },
    navigateToRecommendations: (nav) => {
        nav.navigate(exports.ROUTES.RECOMMENDATIONS);
    },
    navigateToSettings: (nav) => {
        nav.navigate(exports.ROUTES.SETTINGS);
    },
    navigateToNotifications: (nav) => {
        nav.navigate(exports.ROUTES.NOTIFICATIONS);
    },
    navigateToHome: (nav) => {
        nav.navigate(exports.ROUTES.HOME);
    },
};
